import React, { Component } from 'react';
import {
  Box,
  Button,
  Text,
  HStack,
  Link,
  CloseButton,
  Flex
} from '@chakra-ui/react';
import './CookieConsent.css';

// API URL from environment variable with fallback to localhost
const API_URL = process.env.REACT_APP_API_URL || '';

class CookieConsent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showBanner: false
    };
  }

  componentDidMount() {
    // Check if user has already given consent
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      this.setState({ showBanner: true });
    }
  }

  handleAccept = async () => {
    localStorage.setItem('cookieConsent', 'accepted');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    this.setState({ showBanner: false });

    // Log cookie consent to backend if user is logged in
    if (this.props.username && this.props.authenticatedFetch) {
      try {
        await this.props.authenticatedFetch(`${API_URL}/api/privacy/log-cookie-consent`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            username: this.props.username,
            consent_given: true
          })
        });
      } catch (error) {
        console.error('Error logging cookie consent:', error);
      }
    }

    // Reload page to initialize Sentry with consent
    // This ensures analytics only start after explicit user acceptance
    window.location.reload();
  }

  handleReject = async () => {
    localStorage.setItem('cookieConsent', 'rejected');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    this.setState({ showBanner: false });

    // Log cookie rejection to backend if user is logged in
    if (this.props.username && this.props.authenticatedFetch) {
      try {
        await this.props.authenticatedFetch(`${API_URL}/api/privacy/log-cookie-consent`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            username: this.props.username,
            consent_given: false
          })
        });
      } catch (error) {
        console.error('Error logging cookie rejection:', error);
      }
    }
  }

  handleClose = () => {
    // Allow closing without accepting, but banner will reappear on next visit
    this.setState({ showBanner: false });
  }

  render() {
    if (!this.state.showBanner) {
      return null;
    }

    return (
      <Box
        position="fixed"
        bottom="0"
        left="0"
        right="0"
        bg="white"
        borderTop="3px solid"
        borderColor="blue.500"
        boxShadow="0 -4px 20px rgba(0, 0, 0, 0.15)"
        p={4}
        zIndex="9999"
        className="cookie-consent-banner"
      >
        <Flex
          maxW="1200px"
          mx="auto"
          align="center"
          direction={{ base: 'column', md: 'row' }}
          gap={4}
        >
          <Box flex="1">
            <Text fontSize="sm" color="gray.700" mb={2}>
              <strong>Deze website gebruikt cookies</strong>
            </Text>
            <Text fontSize="sm" color="gray.600">
              Wij gebruiken functionele cookies om de website goed te laten werken en analytische cookies om fouten te monitoren en de website te verbeteren.
              Door op "Accepteren" te klikken, gaat u akkoord met ons gebruik van cookies.
              Lees meer in ons{' '}
              <Link
                color="blue.600"
                textDecoration="underline"
                onClick={() => this.props.onRouteChange('privacyPolicy')}
                cursor="pointer"
                fontWeight="600"
              >
                privacybeleid
              </Link>
              .
            </Text>
          </Box>

          <HStack spacing={3} flexShrink={0}>
            <Button
              size="md"
              variant="outline"
              colorScheme="blue"
              onClick={this.handleReject}
            >
              Weigeren
            </Button>
            <Button
              size="md"
              variant="solid"
              colorScheme="blue"
              onClick={this.handleAccept}
            >
              Accepteren
            </Button>
          </HStack>

          <CloseButton
            size="sm"
            onClick={this.handleClose}
            position={{ base: 'relative', md: 'absolute' }}
            top={{ base: 'auto', md: 4 }}
            right={{ base: 'auto', md: 4 }}
          />
        </Flex>
      </Box>
    );
  }
}

export default CookieConsent;
